import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
import { EventApi } from '@fullcalendar/react';

interface Props {
	event: EventApi;
	handleEventMouseLeave: (e: React.MouseEvent<HTMLDivElement>) => void;
	handleEventMouseOver: (e: React.MouseEvent<HTMLDivElement>) => void;
	displaySettings: {
		patientName: boolean;
	};
}

const CalendarDefaultEvent: React.FC<Props> = ({
	event,
	handleEventMouseLeave,
	handleEventMouseOver,
	displaySettings,
}) => {
	const { t } = useTranslation();

	return (
		<div
			className='custom-event'
			style={{ backgroundColor: event.backgroundColor }}
			onMouseLeave={handleEventMouseLeave}
			onMouseEnter={handleEventMouseOver}
			data-event-id={event.id}>
			{event.extendedProps.isConfirmedByPatient && (
				<div className='custom-event__confirmedByPatient'>
					<img src='/dist/icons/green-check.svg' alt='green check' />
				</div>
			)}
			{event?.extendedProps?.createdByPatient && (
				<div className='custom-event__createByPatient' />
			)}
			{event?.extendedProps?.eventAttachments?.length > 0 && (
				<img
					className='custom-event__hasAttachment'
					src='/dist/icons/envelope-solid.svg'
				/>
			)}
			<div className='custom-event__name'>{event.title}</div>
			{displaySettings.patientName && !!event?.extendedProps?.patient?.name && (
				<div className='custom-event__user'>
					{event.extendedProps?.patient?.name}
				</div>
			)}
			{event?.extendedProps?.doctor?.name && (
				<div className='custom-event__user'>
					{t('base.calendar.doctor') + ': ' + event.extendedProps?.doctor?.name}
				</div>
			)}
		</div>
	);
};

export default CalendarDefaultEvent;
